<template>
  <div class="status_page">
    <h3>
      <img
        v-if="isSX"
        src="/static/images/icons/smartexchange_icon_blue.svg"
        class="dashboard-icons"
        alt="smartexchange-icon"
      />
      <img
        v-else
        src="/static/images/icons/submission_icon_blue.svg"
        class="dashboard-icons"
        alt="submission-icon"
      /><span class="pl-12">Project Status</span>
    </h3>
    <div class="piechart" :class="{ 'fix-height': isCombo, 'single-height': !isCombo }">
      <div :id="id"></div>
    </div>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import $ from 'jquery';
import * as d3 from 'd3v4';

export default {
  props: ['sbData', 'isCombo', 'isSX'],
  data() {
    return {
      id: null
    };
  },
  created() {
    this.id = this.isSX ? 'sxSinglePieChart' : 'sbSinglePieChart';
  },
  mounted() {
    this.drawChart();
    window.addEventListener('resize', this.drawChart);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawChart);
  },
  methods: {
    drawChart() {
      const details = cloneDeep(this.sbData.projectStatusGraphData);
      const margin = {
        top: 0,
        right: 20,
        bottom: 0,
        left: 100
      };
      let width =
        parseInt(d3.select(`#${this.id}`).style('width'), 10) - margin.left - margin.right + 55;
      let height = 130;
      let n = 2;
      const itemWidth = 85;
      const itemHeight = 10;
      const radius = Math.floor(Math.min(width, height) / 2);
      let y1 = 45;
      let x1 = -45;
      let segOuterRadius = 45;
      if (window.innerWidth >= 1280 && window.innerWidth <= 1350) {
        // height = 100;
        y1 = 38;
        segOuterRadius = 38;
      }
      if (window.innerWidth >= 1351 && window.innerWidth <= 1410) {
        // height = 100;
        y1 = 40;
        segOuterRadius = 40;
      }
      if (window.innerWidth >= 1250 && window.innerWidth <= 1299) {
        // height = 100;
        y1 = 36;
        segOuterRadius = 36;
      }
      if (window.innerWidth >= 1200 && window.innerWidth <= 1249) {
        // height = 95;
        y1 = 35;
        segOuterRadius = 35;
      }
      let segments = d3.arc().innerRadius(0).outerRadius(segOuterRadius).padAngle(0).padRadius(15);
      if (this.isCombo) {
        n = 3;
        if (details.length <= 2) {
          x1 = -75;
        } else if (details.length === 3) {
          x1 = -115;
        } else {
          x1 = -95;
        }
        y1 = 80;
        height = 180;
        segments = d3.arc().innerRadius(0).outerRadius(70).padAngle(0).padRadius(15);
      }
      /* if (details.length > 4 && !this.isCombo) {
        height = 130;
      } */
      const windowInnerWidth = window.innerWidth;
      if (windowInnerWidth < 500) {
        height = 140;
        segments = d3
          .arc()
          .innerRadius(0)
          .outerRadius(this.isCombo ? 70 : 50)
          .padAngle(0)
          .padRadius(15);
        x1 = -55;
        y1 = 55;
        $('.single-height').css({ maxHeight: 'unset' });
      }
      if (width === 196) {
        width = 204;
      }
      $(`#${this.id} svg`).remove();
      const svg = d3
        .select(`#${this.id}`)
        .append('svg')
        .attr('width', '100%')
        .attr('height', '100%')
        .attr('viewBox', `${-width / 2 - 10} ${-height / 2 + 15} ${width} ${height}`)
        .attr('preserveAspectRatio', 'xMinYMin');
      const data = d3
        .pie()
        .sort(null)
        .value((d) => d.count)(details);
      details.forEach((d) => {
        const d2 = d;
        d2.enabled = true;
      });
      let sections = svg
        .append('g')
        .attr('transform', `${this.isCombo ? `translate(${[-100, 0]})` : `translate(${[0, 0]})`}`)
        .selectAll('path')
        .data(data);
      sections
        .enter()
        .append('path')
        .attr('d', segments)
        .attr('fill', (d) => d.data.color);
      const pie = d3
        .pie()
        .value((d) => d.count)
        .sort(null);
      pie(details).forEach((d) => {
        const s = segments.centroid(d);
        const x = s[0];
        const y = s[1];
        svg
          .append('text')
          .attr('text-anchor', 'middle')
          .attr('alignment-baseline', 'middle')
          .attr(
            'transform',
            `${this.isCombo ? `translate(${[-100 + x, y]})` : `translate(${[x, y]})`} `
          )
          .attr('id', `arcs${d.data.label.replace(/\s/g, '')}`)
          .style('fill', '#fff')
          .style('font-size', `${this.isCombo ? '12px' : '10px'}`)
          .text(d.data.count);
      });
      // Legends Placing and contents starts here.
      let legends = '';
      if (this.isCombo) {
        legends = svg
          .append('g')
          // Legends positioning w.r.to chart will starts here
          .attr('transform', `translate(${[0, -10]})`)
          .selectAll('.legends')
          .data(data);
      } else {
        legends = svg
          .append('g')
          // Legends positioning w.r.to chart will starts here
          .attr('transform', (d, i) => `translate(${x1 + i * 25}, ${y1})`)
          .selectAll('.legends')
          .data(data);
      }

      // Alignment of legends to x-axis or y-axis starts here
      const legend = legends
        .enter()
        .append('g')
        .classed('legends', true)
        .attr('transform', (d, i) => {
          if (details.length === 1) {
            return `translate(${radius - 15 - d.data.label.length * 2}, ${5} )`;
          }
          if (details.length === 2) {
            let x = 50;
            if (this.isCombo) {
              x = 30;
            }
            if (this.id === 'sxSinglePieChart') {
              return `translate(${-45 + i * 105}, ${5})`;
            }
            return `${
              this.isCombo
                ? `translate(0, ${5 + i * 15})`
                : `translate(${radius - x + i * 55}, ${5})`
            }`;
          }
          return `translate(${(i % n) * 120 - (itemWidth - 25)}, ${
            Math.floor(i / n) * itemHeight
          })`;
        });
      // Alignment of legends to x-axis or y-axis ends here
      legend
        .append('circle')
        .attr('cx', `${this.isCombo ? 3 : 2}`)
        .attr('cy', (d, i) => this.getYaxisValues(d, i))
        .attr('r', `${this.isCombo ? 6 : 4}`)
        .attr('fill', (d) => d.data.color)
        .attr('id', (d) => `cir1${d.data.label.replace(/\s/g, '')}`)
        .on('click', (d) => {
          let label = { ...d.data };
          label = label.label;
          const rect = d3.select(`.status_page #cir1${d.data.label.replace(/\s/g, '')}`);
          let enabled = true;
          const totalEnabled = d3.sum(
            details.map((detailsItem) => {
              if (detailsItem.enabled) {
                return 1;
              }
              return 0;
            })
          );
          if (rect.attr('class') === 'disabled') {
            rect.attr('class', '');
            rect.style('fill', (fill) => fill.color);
            rect.style('stroke', '');
          } else {
            if (totalEnabled < 2) return;
            rect.attr('class', 'disabled');
            rect.style('fill', 'transparent');
            rect.style('stroke', 'gray');
            d3.select(`#arc${label}`).style('fill', 'transparent');
            enabled = false;
          }
          pie.value((values) => {
            const d1 = values;
            if (d1.label === label) d1.enabled = enabled;
            if (d1.enabled) {
              return d1.count;
            }
            return 0;
          });
          sections = svg.selectAll('path').data(pie(details));
          sections
            .transition()
            .duration(750)
            .attrTween('d', (dCurrentItem) => {
              const interpolate = d3.interpolate(this.current, dCurrentItem);
              this.current = interpolate(0);
              return (t) => segments(interpolate(t));
            });
          pie(details).forEach((dItem) => {
            const s = segments.centroid(dItem);
            const x = s[0];
            const y = s[1];
            $(`#arcs${dItem.data.label.replace(/\s/g, '')}`).remove();
            svg
              .append('text')
              .attr('text-anchor', 'middle')
              .attr('alignment-baseline', 'middle')
              .attr('transform', `translate(${[x, y]})`)
              .attr('id', `arcs${dItem.data.label.replace(/\s/g, '')}`)
              .style('fill', '#fff')
              .style('font-size', '10px')
              .text(dItem.data.enabled ? dItem.data.count : '');
          });
        });
      // Spacing between legend symbols and legend title starts here
      legend
        .append('text')
        .attr('x', `${this.isCombo ? 30 : 20}`)
        .attr('y', (d, i) => this.getLegendYaxisValues(d, i))
        .style('font-size', `${this.isCombo ? '14px' : '10px'}`)
        .attr('fill', 'rgba(0, 0, 0, 0.7)')
        .attr('transform', () => `translate(${-12}, ${-7})`)
        .text((d) => d.data.label);
      // Spacing between legend symbols and legend title Ends here
    },
    getYaxisValues(d, i) {
      return this.isCombo ? 6 + 6 * i : 6;
    },
    getLegendYaxisValues(d, i) {
      return this.isCombo ? 16 + i * 8 : 16;
    }
  }
};
</script>
<style scoped>
.dashboard-icons {
  width: 32px;
  height: 32px;
}
.h3 span {
  padding-left: 14px;
}
.pl-12 {
  padding-left: 12px;
}
.inside {
  font-size: 25px;
  font-weight: bold;
  fill: white;
}
.label {
  font-size: 25px;
  font-weight: bold;
}
.cursor-pointer {
  word-break: break-all;
  white-space: normal;
}
.status_page h3 {
  margin: 0;
  line-height: 28px;
  font-size: 22px;
  color: #0b3c61;
}
.scroll-div {
  padding: 35px 0 0 10px;
}
.fix-height {
  max-height: 220px;
}
.single-height {
  max-height: 175px;
  overflow-y: auto;
  overflow-x: auto;
  scrollbar-width: thin;
}

rect {
  cursor: pointer;
  stroke-width: 2;
}
rect.disabled {
  fill: transparent !important;
}

.single-card-icons {
  width: 32px;
  height: 32px;
  margin-right: 6px;
  margin-top: -3px;
}
</style>
